import superMeta from '../_COMPONENT/metaComponentNode.mjs'

export default {
    ...superMeta,
    name: '用户操作',
    ownerIdProp: 'sfId',
    ownerTextProp: 'sfName',
    ownerType: 'SF',
    textProp: 'oprTitle',
    type: 'FOPR',
}
